import useApi, { ApiOptions } from '../base/useApi';
import MigrationItemViewDTO from '@src/adapters/dto/migration/MigrationItemViewDTO';

interface Params {
  suggestionId: string;
  migrationId: string;
  status: string;
  inventoryId?: string;
  qtyOpen?: number;
  qtyOnHand?: number;
  note?: string;
  alias?: boolean;
  isLoan?: boolean;
}

interface Result {
  migrationItem: MigrationItemViewDTO | undefined;
}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/migration/save_suggestion/',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};
export const useSaveMigrationSuggestion = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useSaveMigrationSuggestionLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useSaveMigrationSuggestionLazy;
